'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Undraw = require('react-undraw/dist/undraw/Undraw');

var _Undraw2 = _interopRequireDefault(_Undraw);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var IllustrationView = function IllustrationView(_ref) {
  var wrapperClasses = _ref.wrapperClasses,
      name = _ref.name,
      primaryColor = _ref.primaryColor,
      height = _ref.height;
  return _react2['default'].createElement('div', {
    className: wrapperClasses
  }, _react2['default'].createElement(_Undraw2['default'], {
    name: name,
    primaryColor: primaryColor,
    height: height
  }));
}; // UI


IllustrationView.propTypes = {
  primaryColor: _propTypes2['default'].string.isRequired,
  height: _propTypes2['default'].string.isRequired,
  name: _propTypes2['default'].string.isRequired,
  wrapperClasses: _propTypes2['default'].string.isRequired
};
exports['default'] = (0, _react.memo)(IllustrationView);